<button (click)="toggleMenu()" class="hamburger">
  <span class="menu-{{menuState}}">toggle menu</span>
</button>
<div id="search">
  <hub-search></hub-search>
</div>
<top-menu [@slideInOut]="menuState"></top-menu>
<div *ngIf="loggedIn; else loggedOut">
  <router-outlet (click)="hideMenu()"></router-outlet>
</div>
<ng-template #loggedOut>
  <h2 style='background-color:#eee;text-align:center'>
    <a href="/auth/login?goto={{currentRoute}}">Click here to log in</a>
  </h2>
</ng-template>